import axios from 'axios';
import { getLocalizeUrl } from '../../shared/utils/url';

export const postDPORequest = (formData, locale) => {
  return axios.post(
    `${['en_US', 'zh_CN'].includes(locale) ? '' : `/${locale}`}/contactus/api/dpo-request`,
    formData
  );
};

export const postEmailRequestApi = (formData, locale) => {
  return axios.post(
    `${locale === 'en_US' ? '' : `/${locale}`}/contactus/api/send-message`,
    formData
  );
};

export const checkAccountApi = locale => {
  return axios.get(getLocalizeUrl('/contactus/api/check-account', locale));
};

export const checkChatAvailability = (formData, teslaUrl) => {
  // This route accepts "Content-Type: application/json", but the preflight requests fail with a CORS error when running locally.
  // Sending "Content-Type: application/x-www-form-urlencoded" prevents triggering a preflight request.
  // https://developer.mozilla.org/en-US/docs/Web/HTTP/CORS#simple_requests
  const keys = Object.keys(formData);
  const params = keys.map(key => `${key}=${formData[key]}`);
  const data = params.join('&');

  return axios({
    url: `${teslaUrl}/conversation/check-availability`,
    method: 'POST',
    headers: { 'content-type': 'application/x-www-form-urlencoded' },
    data,
  });
};

export const checkOceanaAvailability = (body, teslaUrl) => {
  const keys = Object.keys(body);
  const params = keys.map(key => `${key}=${body[key]}`);
  const data = params.join('&');
  return axios({
    method: 'POST',
    headers: { 'content-type': 'application/x-www-form-urlencoded' },
    data,
    url: `${teslaUrl}/conversation/check-availability-v2`,
  });
};
